<script lang="ts">
  import { toaster, type ToastData } from '$lib/toaster';
  import { cn } from '$lib/utils';
  import type { Toast } from '@significa/svelte-toaster';
  import Icon from './ui/icon/icon.svelte';
  import Spinner from './ui/spinner.svelte';
  import Link from './ui/link.svelte';

  export let toast: Toast<ToastData>;
</script>

<div
  role={toast.data.type === 'error' ? 'alert' : 'status'}
  aria-live="polite"
  class={cn(
    toast.duration === 0 && toast.data.type !== 'loading' ? 'gap-2' : '',
    'flex justify-between bg-highlight border rounded-sm py-2.5 px-3.5 shadow-sm max-w-xs',
    toast.data.description ? 'items-start' : 'items-center'
  )}
>
  <div class={'flex items-start gap-1'}>
    <div class="w-5 h-5 flex items-center justify-center">
      {#if toast.data.type === 'error'}
        <Icon class="text-danger" size="md" icon="alert-hexagon" />
      {:else if toast.data.type === 'success'}
        <Icon class="text-accent" size="md" icon="check-circle" />
      {:else if toast.data.type === 'loading'}
        <Spinner size="xs" />
      {:else}
        <Icon class="opacity-40" size="md" icon="alert" />
      {/if}
    </div>
    <div class="text-sm">
      <p class="leading-normal pt-0.5">{toast.data.title}</p>
      {#if toast.data.description}
        <p class="opacity-40 mt-1">{toast.data.description}</p>
      {/if}
    </div>
  </div>
  {#if toast.data.action}
    <Link
      class="px-2 py-1 text-sm font-semibold"
      on:click={() => {
        if (toast.data.action) {
          toast.data.action.handler();
        }
        toaster.clear(toast.id);
      }}>{toast.data.action.label}</Link
    >
  {/if}
  {#if toast.duration === 0 && toast.data.type !== 'loading'}
    <button
      aria-label="Close Toast"
      class="hover:opacity-40 transition-all flex items-center justify-center"
      on:click={() => toaster.clear(toast.id)}
    >
      <Icon size="md" icon="cross" />
    </button>
  {/if}
</div>
